
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/image-denoiser",
      function () {
        return require("private-next-pages/image-denoiser/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/image-denoiser"])
      });
    }
  